import { useBlocker } from '@tanstack/react-router';
import { useEffect } from 'react';
import { useConfirm } from '@/providers/ConfirmProvider';

export function useFormBlocker(isDirty: boolean, customMessage?: string) {
    const confirm = useConfirm();
    const message = customMessage || 'Bạn có dữ liệu chưa lưu. Bạn có chắc chắn muốn rời khỏi trang này? Dữ liệu chưa lưu sẽ bị mất.';

    // 1. Chặn điều hướng nội bộ (Menu, Back của app)
    useBlocker({
        shouldBlockFn: async ({ current, next }) => {
            if (isDirty && current.fullPath !== next.fullPath) {
                const canLeave = await confirm(message);
                return !canLeave;
            }
            return false;
        }
    });

    // 2. Chặn Tải lại trang (F5) / Đóng Tab
    useEffect(() => {
        const handleBeforeUnload = (e: BeforeUnloadEvent) => {
            if (isDirty) {
                e.preventDefault();
                // Chrome require returnValue to be set
                e.returnValue = message;
                return message;
            }
        };
        
        window.addEventListener('beforeunload', handleBeforeUnload);
        return () => window.removeEventListener('beforeunload', handleBeforeUnload);
    }, [isDirty, message]);
}
